"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("stremio/core");
var useRating = function (ratingInfo) {
    var core = (0, core_1.useCore)();
    var setRating = (0, react_1.useCallback)(function (status) {
        core.transport.dispatch({
            action: 'MetaDetails',
            args: {
                action: 'Rate',
                args: status,
            },
        });
    }, []);
    var content = (ratingInfo === null || ratingInfo === void 0 ? void 0 : ratingInfo.type) === 'Ready' ? ratingInfo.content : null;
    var status = content === null || content === void 0 ? void 0 : content.status;
    var liked = status === 'liked';
    var loved = status === 'loved';
    var onLiked = (0, react_1.useCallback)(function () {
        setRating(status === 'liked' ? null : 'liked');
    }, [status]);
    var onLoved = (0, react_1.useCallback)(function () {
        setRating(status === 'loved' ? null : 'loved');
    }, [status]);
    return {
        onLiked: onLiked,
        onLoved: onLoved,
        liked: liked,
        loved: loved,
    };
};
exports.default = useRating;
